(function ($) {
    if (!$) {
        return;
    }

    const SIZE_MAX_WIDTH = {
        sm: '300px',
        md: '500px',
        lg: '800px',
        xl: '1140px'
    };

    function lockBody() {
        document.body.classList.add('modal-open');
        document.body.style.overflow = 'hidden';
    }

    function unlockBody() {
        if (document.querySelector('.modal')) {
            return;
        }

        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
    }

    function escapeHtml(value) {
        return String(value ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function renderMenu(settings) {
        let menu = '';

        if (Array.isArray(settings.menu) && settings.menu.length > 0) {
            menu = `
                <div class="modal-menu" style="padding:0 1rem 1rem;border-bottom:1px solid var(--border-color);">
                    <div style="display:flex;flex-wrap:wrap;gap:.5rem;">
            `;

            for (let i = 0; i < settings.menu.length; ++i) {
                menu += `
                    <a
                        class="${escapeHtml(settings.menu[i].class)}"
                        href="${escapeHtml(settings.menu[i].url)}"
                        style="display:inline-flex;align-items:center;border-radius:.75rem;padding:.45rem .75rem;text-decoration:none;font-size:.8125rem;font-weight:600;background:var(--hover-bg);color:var(--text-color);"
                    >${escapeHtml(settings.menu[i].name)}</a>
                `;
            }

            menu += `
                    </div>
                </div>
            `;
        }

        return menu;
    }

    function getDialogStyle(settings) {
        if (settings.fullscreen) {
            return 'position:relative;width:min(100vw,100%);max-width:100vw;height:100vh;max-height:100vh;margin:0;';
        }

        const maxWidth = SIZE_MAX_WIDTH[settings.size] || SIZE_MAX_WIDTH.md;

        return `position:relative;width:min(${maxWidth},calc(100vw - 2rem));max-width:${maxWidth};max-height:calc(100dvh - 5rem);margin:0 auto;`;
    }

    function getContentStyle(settings) {
        if (settings.fullscreen) {
            return 'display:flex;flex-direction:column;height:100vh;min-height:100vh;background:var(--white-bg);color:var(--text-color);border-radius:0;overflow:hidden;box-shadow:none;';
        }

        return 'display:flex;flex-direction:column;max-height:calc(100dvh - 5rem);background:var(--white-bg);color:var(--text-color);border:1px solid var(--border-color);border-radius:1rem;overflow:hidden;box-shadow:0 20px 50px rgba(15,23,42,.18);';
    }

    function getRootStyle(settings) {
        if (settings.fullscreen) {
            return 'position:fixed;inset:0;z-index:2000;display:flex;align-items:stretch;justify-content:center;padding:0;';
        }

        return 'position:fixed;inset:0;z-index:2000;overflow:auto;padding:clamp(1rem,4vh,3.5rem) 1rem 1rem;';
    }

    function showModal($modal) {
        const modalElement = $modal.get(0);

        if (!modalElement) {
            return;
        }

        lockBody();

        requestAnimationFrame(function () {
            $modal.attr('aria-hidden', 'false');
            $modal.find('[data-modal-backdrop]').css('opacity', '1');
            $modal.find('[data-modal-dialog]').css({
                opacity: '1',
                transform: 'translateY(0)'
            });
            $modal.trigger('taskello.modal:shown');
            $modal.trigger('shown.bs.modal');
        });
    }

    function destroyModal($source) {
        const $modal = $source.closest('[data-modal-root]');

        if (!$modal.length) {
            unlockBody();
            return;
        }

        $modal.trigger('taskello.modal:hide');
        $modal.trigger('hide.bs.modal');

        const $backdrop = $modal.find('[data-modal-backdrop]');
        const $dialog = $modal.find('[data-modal-dialog]');

        $backdrop.css('opacity', '0');
        $dialog.css({
            opacity: '0',
            transform: 'translateY(12px)'
        });

        window.setTimeout(function () {
            $modal.remove();
            unlockBody();
            $(document).trigger('taskello.modal:hidden', [$modal]);
            $(document).trigger('hidden.bs.modal', [$modal]);
        }, 180);
    }

    $.fn.ajaxmodal = function (action, options = {}) {
        const debug = false;
        const $element = $(this);

        function debugLog(...message) {
            if (!debug) {
                return;
            }

            console.log('DEBUG', ...message);
        }

        function disable() {
            $element.attr('aria-disabled', 'true').addClass('tw-pointer-events-none tw-opacity-60');
        }

        function enable() {
            $element.removeAttr('aria-disabled').removeClass('tw-pointer-events-none tw-opacity-60');
        }

        this.each(function () {
            debugLog('modal', { action: action, options: options });

            if (action === 'create' || !action) {
                disable();

                const settings = $.extend(
                    {
                        title: $(this).attr('data-title') ?? 'Modal',
                        body: '',
                        id: `modal-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
                        url: $(this).attr('href'),
                        size: null,
                        fullscreen: false,
                        menu: [],
                        type: 'GET',
                        data: {},
                        class: {
                            body: '',
                            modal: '',
                            content: ''
                        }
                    },
                    options
                );

                $.ajax({
                    url: settings.url,
                    type: settings.type,
                    data: settings.data,
                    success: function (response, textStatus, request) {
                        let preventDefault = false;

                        $element.trigger('modallink.success', [response, $element, function () {
                            preventDefault = true;
                        }]);

                        if (preventDefault) {
                            return;
                        }

                        if (request.getResponseHeader('X-Modal-Config') !== null) {
                            for (const [key, value] of Object.entries(JSON.parse(atob(request.getResponseHeader('X-Modal-Config'))))) {
                                if (value !== null) {
                                    settings[key] = value;
                                }
                            }
                        }

                        if (typeof response === 'object' && response.type === 'redirect') {
                            window.location.href = response.url;
                            return;
                        }

                        const menu = renderMenu(settings);

                        $('body').append(`
                            <div
                                class="modal ${escapeHtml(settings.class.modal)}"
                                data-modal-root
                                data-testid="modal-root"
                                id="${escapeHtml(settings.id)}"
                                tabindex="-1"
                                aria-hidden="true"
                                style="${getRootStyle(settings)}"
                            >
                                <div class="modal-backdrop" data-modal-backdrop style="position:absolute;inset:0;background:rgba(15,23,42,.52);backdrop-filter:blur(3px);opacity:0;transition:opacity .18s ease;"></div>
                                <div class="modal-dialog" data-modal-dialog style="${getDialogStyle(settings)}opacity:0;transform:translateY(12px);transition:opacity .18s ease, transform .18s ease;">
                                    <div class="modal-content ${escapeHtml(settings.class.content)}" data-modal-content style="${getContentStyle(settings)}">
                                        <div class="modal-header" data-modal-header style="display:flex;align-items:flex-start;justify-content:space-between;gap:1rem;padding:1rem 1rem .75rem;border-bottom:1px solid var(--border-color);">
                                            <h5 class="modal-title" style="margin:0;font-size:1.05rem;font-weight:700;line-height:1.3;color:var(--text-color);">${escapeHtml(settings.title)}</h5>
                                            <button type="button" class="btn-close" data-modal-close aria-label="Close" style="display:inline-flex;align-items:center;justify-content:center;width:2rem;height:2rem;border:0;border-radius:.75rem;background:transparent;color:var(--text-muted);cursor:pointer;font-size:1.25rem;line-height:1;flex-shrink:0;">&times;</button>
                                        </div>
                                        ${menu}
                                        <div class="modal-body ${escapeHtml(settings.class.body)}" data-modal-body data-testid="modal-body" data-url="${escapeHtml(settings.url)}" style="flex:1;min-height:0;overflow:auto;padding:1rem;">
                                            ${response}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `);

                        const $modal = $(document.getElementById(settings.id));
                        showModal($modal);
                        enable();
                    },
                    error: function (xhr, status, error) {
                        window.Taskello?.debugLog?.('test,test', [xhr, status, error]);

                        if (xhr.status === 401) {
                            window.Taskello?.showToast('Brak uprawnień do strony.', 'error');
                        } else if (xhr.status === 404) {
                            window.Taskello?.showToast('Strona nie została znaleziona lub nie masz uprawnień.', 'error');
                        } else {
                            window.Taskello?.showToast('Wystąpił błąd podczas przetwarzania żądania.', 'error');
                        }

                        enable();
                    }
                });
            } else if (action === 'refresh') {
                const $modalBody = $(this).find('[data-modal-body]');

                $.ajax({
                    url: $modalBody.attr('data-url'),
                    success: (response, textStatus, request) => {
                        let settings = {};

                        $modalBody.html(response);

                        if (request.getResponseHeader('X-Modal-Config') !== null) {
                            for (const [key, value] of Object.entries(JSON.parse(atob(request.getResponseHeader('X-Modal-Config'))))) {
                                if (value !== null) {
                                    settings[key] = value;
                                }
                            }
                        }

                        const menu = renderMenu(settings);

                        $modalBody.closest('[data-modal-root]').find('.modal-menu').replaceWith(menu);
                    }
                });
            } else if (action === 'destroy') {
                destroyModal($(this));
            } else {
                console.warn(`Unknown action: ${action}`);
            }
        });
    };
})(window.jQuery || window.$);

(function ($) {
    if (!$) {
        return;
    }

    $(document).on('click', '.modallink', function (e) {
        e.preventDefault();
        $(this).ajaxmodal('create');
    });

    $(document).on('click', '.modal [data-modal-close]', function (e) {
        e.preventDefault();
        $(this).closest('.modal').ajaxmodal('destroy');
    });

    $(document).on('click', '.modal', function (e) {
        if ($(e.target).is('.modal')) {
            e.stopPropagation();
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key !== 'Escape') {
            return;
        }

        const $modal = $('.modal').last();

        if ($modal.length) {
            $modal.ajaxmodal('destroy');
        }
    });
})(window.jQuery || window.$);
